export var AGE_VERIFICATION_STEPS;
(function (AGE_VERIFICATION_STEPS) {
    AGE_VERIFICATION_STEPS["DISCLAIMER"] = "DISCLAIMER";
    AGE_VERIFICATION_STEPS["AGE_VERIFICATION"] = "AGE_VERIFICATION";
})(AGE_VERIFICATION_STEPS || (AGE_VERIFICATION_STEPS = {}));
export var AGE_VERIFICATION_METHOD;
(function (AGE_VERIFICATION_METHOD) {
    AGE_VERIFICATION_METHOD["DIIA_ASYNC"] = "diia_async";
    AGE_VERIFICATION_METHOD["PASS"] = "portone_async";
})(AGE_VERIFICATION_METHOD || (AGE_VERIFICATION_METHOD = {}));
//# sourceMappingURL=HardAgeVerificationPopup.types.js.map